import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EMAIL_OPENFORGE } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { PARTNERS_OPENFORGE_FAQS } from '../../constants';

@Component({
  selector: 'app-partners-openforge-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './partners-openforge-faq-section.component.html',
  styleUrl: './partners-openforge-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersOpenforgeFaqSectionComponent {
  protected readonly emailOpenforge = EMAIL_OPENFORGE;
  protected readonly items = PARTNERS_OPENFORGE_FAQS;
}
